(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["restore-header"] && !Shopify.designMode) return;
  try {
    document.addEventListener('shopify:cart:lines-update', function(event) {
  event.promise?.then(function(result) {
    const count = result.cart?.totalQuantity ?? result.detail?.itemCount;
    if (typeof count === 'number') document.querySelectorAll('[data-rl-cart-count]').forEach(function(el) { el.textContent = count; });
  }).catch(function() {});
});
  } catch(e) { console.error(e); }
})();

})();
